import React from "react";
import EditForm from "../../components/EditExpense/EditForm";

const EditExpense = () => {
  return (
    <div>
      <EditForm />
    </div>
  );
};

export default EditExpense;
